// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YHuPL","pills":"styles_pills__JROt+","pill":"styles_pill__0SMHv"};